<template>
  <main v-if="article">
    <h1 v-if="type === 'article'" class="article-title">
      {{ article.subject }}
    </h1>
    <div class="article-subtitle">
      <!-- If need subtitle -->
    </div>
    <div v-if="type === 'article'" class="article-info">
      <time :datetime="displayPublishedDate" class="date">
        {{ displayPublishedDate }}
      </time>
      <span v-if="authors && authors.length > 0">
        ‧
      </span>
      <span v-for="author in authors" :key="author.id" class="byline">
        <RouterLink
          :to="{ name:'authorById', params: { locale: $i18n.localePath(), id: author.id } }"
          :title="author.name"
          class="author"
        >
          {{ author.name }}
        </RouterLink>
      </span>
    </div>
    <div :class="[{ limit: isLimit }, fontSize]" class="article-content muzik-markdown content">
      <div id="article-content">
      <!-- <div id="article-content" v-html="replaceContent"> -->
        <!--  -->
      </div>
      <div class="mask" />
    </div>
  </main>
</template>
<script>
import mdc from '@/utils/markdown-core/index-browser'

export default {
  name: 'ArticleContent',
  components: {},
  props: {
    article: {
      type: Object,
      default: () => {}
    },
    authors: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    isLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      replaceContent: '',
      articleContent: ''
    }
  },
  computed: {
    fontSize() {
      return this.$store.state.article.fontSizeLevel.toLowerCase()
    },
    displayPublishedDate() {
      return this.article && this.article.published_at ? this.article.published_at.split(' ')[0] : ''
    }
  },
  watch: {},
  created() {
  },
  mounted() {
    if (document.getElementById('article-content') && document.getElementById('article-content').getElementsByTagName('iframe')) {
      // let iframe = document.getElementById('article-content').getElementsByTagName('iframe')[0]
      // console.log('iframe: ', iframe)
      // let doc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow.document
      // console.log('doc: ', doc)
      // let embedded = doc.getElementById('app')
      // console.log('embedded: ' , embedded)
      // iframe.onload = this.resizeIframe(iframe)
      // function resizeIframe(obj) {
      //   console.log('&&&&')
      //   console.log(iframe.contentWindow.document.getElementById('embedded-player'))
      //   // console.log('resizeIframe')
      //   // obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
      //   // console.log(obj.contentWindow.document.body.scrollHeight)
      // }
      //   console.log('iframe: ', iframe, iframe.offsetHeight, iframe.scrollHeight)
      //   let doc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow.document
      //   let body = doc.body
      //   // let html = doc.documentElement.getElementById('app')
      //   // console.log(html)
      //   let height = Math.max(body.scrollHeight, body.offsetHeight)
      //   console.log('height: ', height)
      //   // iframe.style.height = height + 'px'
      //   if (iframe.contentDocument && iframe.contentDocument.body.offsetHeight) {
      //     height = iframe.contentDocument.body.offsetHeight
      //   } else if (iframe.Document && iframe.Document.body.scrollHeight) {
      //     height = iframe.Document.body.scrollHeight
      //   }
      //   console.log('height2: ', height)
      //   iframe.style.height = height + 'px'
      //   console.log(doc, doc.documentElement.clientHeight, doc.documentElement.scrollHeight, doc.documentElement.offsetHeight)
      //   console.log(iframe.contentWindow.document.body.scrollHeight, iframe.contentWindow.document.documentElement.scrollHeight)

      //   let iframeInner = iframe.contentDocument || iframe.contentWindow
      //   console.log(iframeInner.getElementsByTagName('body')[0])
    }
    if (this.article.content) {
      this.articleContent = mdc.init(this.article.content)
    }
  },
  updated() {},
  methods: {
    resizeIframe(obj) {
      console.log('***** resizeIframe')
      console.log(obj.contentWindow.document)
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/variables.scss';

.article-info {
  // min-height: 48px;
  margin-bottom: 36px;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: $grey-9b;
  .author {
    @include default-link-hover();
  }
}
.article-content {
  position: relative;
  margin-bottom: 36px;
  &.limit{
    @include ellipsis-with-lines(3);
    .mask{
      position: absolute;
      top: 40px;
      display: block;
      width: 100%;
      height: 100px;
      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 1%, #ffffff);
    }
  }
}

@media only screen and (min-width: 1440px) {
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}

@media only screen and (max-width: 767.98px) {
}
</style>
